/** 与后台空库时前端使用的默认协议文书一致，供协议配置页与 API 合并逻辑使用 */

export type AgreementDocType = "charter" | "disclaimer" | "privacy" | "code";

export interface AgreementDocumentModel {
  id: string;
  title: string;
  type: AgreementDocType;
  content: string;
  requireSign: boolean;
  version: string;
  updatedAt: string;
  isActive: boolean;
}

export const AGREEMENT_TYPE_ORDER: AgreementDocType[] = ["charter", "disclaimer", "privacy", "code"];

/** 将接口返回与默认范本合并（含四类文书各一条）。 */
export function mergeSavedAgreementDocuments(rows: AgreementDocumentModel[]): AgreementDocumentModel[] {
  const defaults = getDefaultAgreementDocuments();
  if (!rows.length) return defaults;
  const byType = new Map(defaults.map((d) => [d.type, { ...d }]));
  for (const r of rows) {
    if (AGREEMENT_TYPE_ORDER.includes(r.type)) byType.set(r.type, { ...r });
  }
  return AGREEMENT_TYPE_ORDER.map((t) => byType.get(t)!);
}

export function getDefaultAgreementDocuments(): AgreementDocumentModel[] {
  return [
    {
      id: "d1",
      title: "球迷协会管理章程",
      type: "charter",
      requireSign: false,
      version: "v2.1",
      updatedAt: "2025-12-01",
      isActive: true,
      content: `第一章 总则

第一条　本协会名称以主管机关核准登记及本系统「基本信息」中的全称为准（以下简称"本协会"）。

第二条　本协会是由热爱足球的球迷自愿组成的非营利性社会团体，致力于促进球迷文化，维护球迷权益，组织球迷交流活动。

第三条　本协会遵守中华人民共和国相关法律法规，遵守社会道德规范，维护社会稳定，促进社会主义精神文明建设。

第二章 会员

第四条　凡认同本协会章程，热爱足球运动，经本协会审核通过者，可成为本协会会员。

第五条　会员享有以下权利：
（一）参与本协会组织的各类活动；
（二）享受本协会提供的会员专属服务；
（三）对本协会工作提出意见和建议；
（四）有选举权和被选举权。

第六条　会员履行以下义务：
（一）遵守本协会章程和各项规定；
（二）爱护本协会形象，文明观赛；
（三）按时缴纳会费（如有）；
（四）积极参与本协会组织的活动。

第三章 组织机构

第七条　本协会设会长一名，副会长若干名，秘书长一名，并下设各职能部门。

第八条　本协会最高权力机构为会员大会，每年至少召开一次。

第四章 附则

第九条　本章程经会员大会通过后施行，解释权归本协会理事会。`,
    },
    {
      id: "d2",
      title: "会员服务免责声明",
      type: "disclaimer",
      requireSign: true,
      version: "v1.3",
      updatedAt: "2026-01-15",
      isActive: true,
      content: `免责声明

尊敬的球迷协会会员：

请在加入本协会前仔细阅读以下免责声明，您提交入会申请即表示您已阅读、理解并同意本声明的全部内容。

一、活动风险

1. 本协会组织的各类观赛活动、客场出行等，参与者应自行评估个人健康状况及活动风险。

2. 参与者在活动中发生的人身意外伤害，本协会不承担法律责任，建议参与者自行购买相关保险。

3. 客场出行活动中，本协会仅负责组织协调，交通、住宿等费用由参与者自行承担，如因不可抗力导致行程变更，本协会不承担赔偿责任。

二、个人信息

1. 本协会收集的会员个人信息仅用于协会内部管理和活动组织，不会向第三方泄露。

2. 会员应确保所提供信息的真实性和准确性，如因虚假信息导致的任何问题，由会员本人承担。

三、行为规范

1. 会员在观赛及参与活动中，须遵守场馆规定和公共秩序，文明观赛，杜绝任何暴力、歧视行为。

2. 因会员个人行为违规导致的任何后果，由会员本人承担相应责任，本协会保留取消其会员资格的权利。

本人已详细阅读上述免责声明，完全理解并同意遵守其中的各项条款。

签名：_______________　　日期：_______________`,
    },
    {
      id: "d3",
      title: "隐私政策",
      type: "privacy",
      requireSign: false,
      version: "v1.1",
      updatedAt: "2025-10-01",
      isActive: true,
      content: `隐私政策

本协会高度重视用户隐私保护。本隐私政策说明了本协会如何收集、使用和保护您的个人信息。

一、信息收集

我们收集的信息包括：姓名、手机号码、电子邮箱、身份证号码（用于实名核验）等。

二、信息使用

您的个人信息将用于：
- 会员身份验证和管理
- 活动通知和组织
- 会员服务提供

三、信息保护

我们采取行业标准的技术措施保护您的个人信息安全。

四、信息共享

我们不会将您的个人信息出售或出租给第三方。`,
    },
    {
      id: "d4",
      title: "球迷行为准则",
      type: "code",
      requireSign: true,
      version: "v3.0",
      updatedAt: "2026-02-20",
      isActive: true,
      content: `球迷行为准则

作为本协会的成员，我们共同承诺：

一、文明观赛
1. 尊重裁判判决，不做无理谩骂和嘘声；
2. 尊重对手球队球迷，展现友好风范；
3. 爱护场馆设施，不破坏公共财物；
4. 保持观赛区域整洁，离场时带走自己的垃圾。

二、安全第一
1. 不携带危险物品入场；
2. 不在禁烟区域吸烟；
3. 遵守场馆疏散指引，保持紧急通道畅通；
4. 如发现安全隐患，及时报告场馆工作人员。

三、正面支持
1. 以积极正面的方式为球队加油鼓劲；
2. 不散布虚假信息，不恶意攻击球员和教练；
3. 在社交媒体上理性表达，维护协会良好形象。

违反本准则者，本协会将视情节轻重给予警告、暂停会员资格或开除会籍等处分。

本人郑重承诺遵守以上行为准则。

签名：_______________　　日期：_______________`,
    },
  ];
}
